export class HandsontableFieldTypeContrants {
    public static checkbox = 'checkbox';
    public static combobox = 'combobox';
    public static radio = 'radiobox';
    public static dropdown = 'dropdown';
    public static input = 'input';
    public static date = 'date';
    public static text = 'text';
    public static textbox = 'textbox';
    public static moneyFormat = 'number_money_format';
    public static number = 'number';
    public static numberPercent = 'number_percent_format';
    public static numberToText = 'NUMBERTOTEXT';
    public static autocomplete = 'autocomplete';
    public static numeric = 'numeric';
    public static phone = 'phone';
    public static email = 'email';
    public static taxCode = 'ma_so_thue'
}